import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import SignedInLinks from "./SignedInLinks";
import SignedOutLinks from "./SignedOutLinks";
import SearchField from "../atoms/SearchField";

const NavBar = props => {
  
  const { auth, profile } = props;
  // console.log(auth);
  // console.log(props);

  const links = auth.uid ? (
    <SignedInLinks profile={profile} />
  ) : (
    <SignedOutLinks />
  );

  return (
    <Fragment>
      <div className="navbar-fixed" style={{ marginBottom: "52px" }}>
        <nav
          className="nav-extended blue accent-4"
          style={{
            minHeight: "30px !important",
            lineHeight: "30px !important"
          }}
        >
          <div
            className="nav-wrapper blue accent-4"
            style={{
              minHeight: "30px !important",
              lineHeight: "30px !important"
            }}
          >
            <Link to="/" className="brand-logo left">
              <i
                className="large material-icons"
                style={{ fontSize: "4rem", paddingLeft: "2rem" }}
              >
                bubble_chart
              </i>
            </Link>
            {links}
          </div>
          <div
            className="blue accent-4"
            style={{ lineHeight: "30px", padding: "0 0 0 50%" }}
          >
            <SearchField />
          </div>
        </nav>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => {
  // console.log(state);
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(NavBar);
